import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * The components read their labels through react-i18next's useTranslation().
 * A previous local replacement of @feed-factory/feed-factory.translation
 * reimplemented addResourceBundle/changeLanguage on a standalone class, so the
 * bundles never reached react-i18next and every label rendered as its raw key
 * ("veluwe:route.title"). This is the i18next instance those calls belong to.
 */
i18n.use(initReactI18next).init({
  lng: 'nl',
  fallbackLng: 'nl',
  ns: ['veluwe'],
  defaultNS: 'veluwe',
  resources: {},
  // The locale files use flat keys that contain dots ("route.title"), so
  // i18next must not treat the dot as a path separator.
  keySeparator: false,
  nsSeparator: ':',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export const translationService = i18n;

export default i18n;
